export const scrollToRef = ({ current }: React.MutableRefObject<null>) => {
    if (current) {
        current.scrollIntoView({ behavior: "smooth" });
    }
};
